import Popup from 'reactjs-popup'
import './UnsavedDataPopup.css'
import React from 'react'

export default function UnsavedDataPopup({ open, onConfirm, onCancel }) {
	if (open) {
		document.body.classList.add('disabled')
	}
	function onCancelButtonClick() {
		document.body.classList.remove('disabled')
		onCancel()
	}
	function onConfirmButtonClick() {
		document.body.classList.remove('disabled')
		onConfirm()
	}
	return (
		<Popup open={open} closeOnDocumentClick={false}>
			<div className='unsavedDataPopup'>
				<p>
					Ungespeicherte Änderungen! Willst du die Seite wirklich verlassen?
				</p>
				<button onClick={onCancelButtonClick} style={{ marginRight: '10px' }}>
					Cancel
				</button>
				<button onClick={onConfirmButtonClick}>Ok</button>
			</div>
		</Popup>
	)
}
